import React from 'react';
interface MasteryBarProps {
  value: number;
}
export function MasteryBar({
  value
}: MasteryBarProps) {
  const color = value >= 80 ? 'bg-emerald-500' : value >= 60 ? 'bg-amber-500' : value >= 40 ? 'bg-orange-400' : 'bg-red-400';
  return <div className="flex items-center gap-2" data-id="element-4747">
      <div className="w-16 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-4748">
        <div className={`h-1.5 rounded-full ${color}`} style={{
        width: `${Math.max(0, Math.min(100, value))}%`
      }} data-id="element-4749" />
      </div>
      <span className="text-xs text-gray-600 tabular-nums" data-id="element-4750">{value}%</span>
    </div>;
}